










import { Component } from 'vue-property-decorator';
import MixinPage from '@/plugins/podolib/services/helper/mixins/page';

import Page from '@/components/Page.vue';
import SettingsLanguage from '@/components/settings/SettingsLanguage.vue';

@Component({
  components: {
    SettingsLanguage,
    Page,
  },
  metaInfo() {
    return {
      title: this.$options.filters!.capitalize(this.$tc('commons.standards.setting', 2)),
      titleTemplate: '%s | Podosmart',
    };
  },
  created() {
    this.$pdc.bus!.emitDebug('app:navbar:breadcrumbs', [
      {
        text: this.$tc('commons.standards.setting', 2),
        disabled: false,
        to: '/settings',
      },
    ]);
  },
})
export default class PageSettings extends MixinPage {}
